import { useEffect, useState } from 'react';
import { getSlideshow } from '../api/HomeApi';
import {showError} from "../../../utils/toastHelper";

export const useSlideshow = () => {
    const [slides, setSlides] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchSlides = async () => {
            try {
                const params = {
                    count: 8,
                    special: true,
                    list: 1,
                    slideshow_id: 3
                }
                const data = await getSlideshow(params);
                setSlides(data?.data || []);
            } catch (err) {
                 showError( err);
            } finally {
                setLoading(false);
            }
        };
        fetchSlides();
    }, []);

    return { slides, loading };
};